export const TOAST_MESSAGE_DURATION_SECONDS = 10;
export const saveErrorText = 'Error saving alert. Try again later.';
export const saveSuccessText = 'Alert saved successfully.';
export const deleteErrorText = 'Error deleting alert. Try again later.';
export const deleteSuccessText = 'Alert deleted successfully.';
export const updateUserPreferenceErrorText = 'Changes not saved, please try again later.';
export const updateUserPreferenceSuccessText = 'Changes have been saved.';
